import { NoticeExtractorAttachmentResponseDto } from 'app/API';
import { DataRows } from '../DataRows';

type TProps = {
  attachments?: NoticeExtractorAttachmentResponseDto[];
};

export function AttachmentsCard({ attachments = [] }: TProps) {
  return (
    <section className="col-span-full min-w-0 rounded-[10px] border border-border bg-surface p-3.5">
      <h3 className="mb-2.5 text-sm font-bold leading-5 text-foreground">Attachments</h3>
      {attachments.length ? (
        <div className="grid gap-2.5">
          {attachments.map((attachment, index) => (
            <div
              className="rounded-lg border border-border bg-surface-muted p-2.5"
              key={`${attachment.identifier ?? 'attachment'}-${index}`}
            >
              <DataRows
                rows={[
                  { label: 'Identifier', value: attachment.identifier },
                  { label: 'Summary', value: attachment.content_summary },
                ]}
              />
            </div>
          ))}
        </div>
      ) : (
        <span className="text-xs leading-[18px] text-foreground-muted">No attachments found</span>
      )}
    </section>
  );
}
